// Markdown de las respuestas del asistente: GFM (tablas, listas) sin HTML crudo.
import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Box, Link, Text, useColorModeValue } from '@chakra-ui/react';

export const tieneTabla = (texto) => /(^|\n)\s*\|?\s*:?-{3,}:?\s*\|/.test(String(texto || ''));

const MensajeMarkdown = ({ texto, compacto = true }) => {
  const borde = useColorModeValue('gray.200', 'whiteAlpha.300');
  const cabecera = useColorModeValue('gray.50', 'whiteAlpha.100');
  const tam = compacto ? 'sm' : 'md';
  const componentes = {
    p: ({ children }) => (
      <Text fontSize={tam} mb={2} lineHeight="1.55">
        {children}
      </Text>
    ),
    a: ({ href, children }) => (
      <Link href={href} color="blue.500" isExternal rel="noopener noreferrer">
        {children}
      </Link>
    ),
    ul: ({ children }) => (
      <Box as="ul" pl={5} mb={2} fontSize={tam}>
        {children}
      </Box>
    ),
    ol: ({ children }) => (
      <Box as="ol" pl={5} mb={2} fontSize={tam}>
        {children}
      </Box>
    ),
    li: ({ children }) => (
      <Box as="li" mb={1}>
        {children}
      </Box>
    ),
    code: ({ children }) => (
      <Box as="code" px={1} borderRadius="sm" bg={cabecera} fontSize="0.85em">
        {children}
      </Box>
    ),
    table: ({ children }) => (
      <Box overflowX="auto" mb={3} borderWidth="1px" borderColor={borde} borderRadius="md">
        <Box as="table" w="100%" fontSize={compacto ? 'xs' : 'sm'} sx={{ borderCollapse: 'collapse' }}>
          {children}
        </Box>
      </Box>
    ),
    th: ({ children, style }) => (
      <Box as="th" px={2} py={1.5} textAlign={style?.textAlign || 'left'} bg={cabecera} borderBottomWidth="1px"
        borderColor={borde} whiteSpace="nowrap" fontWeight="semibold">
        {children}
      </Box>
    ),
    td: ({ children, style }) => (
      <Box as="td" px={2} py={1.5} textAlign={style?.textAlign || 'left'} borderBottomWidth="1px" borderColor={borde}
        whiteSpace={compacto ? 'nowrap' : 'normal'}>
        {children}
      </Box>
    ),
  };
  return (
    <ReactMarkdown remarkPlugins={[remarkGfm]} skipHtml components={componentes}>
      {String(texto || '')}
    </ReactMarkdown>
  );
};

export default MensajeMarkdown;
